import BaseComponent from "../../../../lib/components/BaseComponent";
import PropTypes from "prop-types";
import T from "../../../model/system/text_translations/Translator";
import LoadingButton from "@mui/lab/LoadingButton";
import Grid from "@mui/material/Grid2";
import React, {createRef} from "react";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import {deDE} from "@mui/x-data-grid/locales";
import {Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, styled} from "@mui/material";
import {Add, Close, Delete, Edit} from "@mui/icons-material";
import SysLastValueRead from "../../../../lib/model/service/system/dto/SysLastValueRead";
import SystemService from "../../../../lib/model/service/system/SystemService";
import TableButtonGroup from "../entity/tableButtonGroup/TableButtonGroup";
import Button from "../buttons/Button";
import VerticalLayout from "../../../../lib/components/layouts/VerticalLayout";
import SysLastValueDelete from "../../../../lib/model/service/system/dto/SysLastValueDelete";
import SysLastValueWrite from "../../../../lib/model/service/system/dto/SysLastValueWrite";
import shortid from "shortid";
import ConfirmationDialog from "../../../../lib/components/dialogs/ConfirmationDialog";
import DialogNewFilterEntry from "./DialogNewFilterEntry";
import FilterProperties from "../../../model/service/system/FilterProperties";
import {toast} from "react-toastify";
import CM from "../../../model/system/CM";

const StyledGridOverlay = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  '& .ant-empty-img-1': {
    fill: theme.palette.mode === 'light' ? '#aeb8c2' : '#262626',
  },
  '& .ant-empty-img-2': {
    fill: theme.palette.mode === 'light' ? '#f5f5f7' : '#595959',
  },
  '& .ant-empty-img-3': {
    fill: theme.palette.mode === 'light' ? '#dce0e6' : '#434343',
  },
  '& .ant-empty-img-4': {
    fill: theme.palette.mode === 'light' ? '#fff' : '#1c1c1c',
  },
  '& .ant-empty-img-5': {
    fillOpacity: theme.palette.mode === 'light' ? '0.8' : '0.08',
    fill: theme.palette.mode === 'light' ? '#f5f5f5' : '#fff',
  },
}));

class FilterListDialog extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      mode: '',
      listId: -1,
      isLoading: false,
      rowsId: -1,
      data: this.props.data,
      actualRowId: -1,
      openYesNo: false,
      openNewFilterEntryDialog: false,
      nameOfList: '',
      useForSending: false,
      openAlertNoDataSelectionDialog: false,
      selectionModel: []
    }
    this.newFilterEntryDialogRef = createRef();
  }

  onRefreshListener = (e) => {
    this.props.parent.doLoadFilterListDialog();
  }

  static private_customNoRowsOverlay() {
    return (
      <StyledGridOverlay>
        <svg
          style={{flexShrink: 0}}
          width="240"
          height="200"
          viewBox="0 0 184 152"
          aria-hidden
          focusable="false"
        >
          <g fill="none" fillRule="evenodd">
            <g transform="translate(24 31.67)">
              <ellipse
                className="ant-empty-img-5"
                cx="67.797"
                cy="106.89"
                rx="67.797"
                ry="12.668"
              />
              <path
                className="ant-empty-img-1"
                d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
              />
              <path
                className="ant-empty-img-2"
                d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
              />
              <path
                className="ant-empty-img-3"
                d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
              />
            </g>
            <path
              className="ant-empty-img-3"
              d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
            />
            <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
              <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815"/>
              <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"/>
            </g>
          </g>
        </svg>
        <Box sx={{mt: 1}}>{T.label_no_data()}</Box>
      </StyledGridOverlay>
    );
  }

  static loadFilterList(sysLastValueId, callBack, useAsSendingDialog) {
    SystemService.doRequest(new SysLastValueRead(sysLastValueId), (response) => {
      let rowsForGrid = [];
      let data = [];
      for (let index in response.data.data) {
        let record = response.data.data[index];
        let filterProperties = CM.parseJsonString(record.value);

        let dataElement = {
          listName: filterProperties.listName,
          useForSending: filterProperties.useForSending,
          isFavorite: filterProperties.favorite,
          type: filterProperties.type,
          createdDateTime: record.syscreateddatetime,
          query: filterProperties.value,
          valueid: record.valueid,
        };
        if (!useAsSendingDialog || dataElement.useForSending) {
          dataElement.id = parseInt(index);
          rowsForGrid.push(FilterListDialog.dataToRow(dataElement));
          data.push(dataElement);
        }
      }
      callBack(rowsForGrid, data);
    }, 'Es konnten keine Daten geliefert werden!');
  }

  static dataToRow(data) {
    return {
      id: data.id,
      listName: (data.listName ? data.listName : ''),
      useForSending: (data.useForSending ? data.useForSending : false),
      isFavorite: (data.favorite ? data.favorite : false),
      createdDateTime: (data.syscreateddatetime ? data.syscreateddatetime : ''),
    };
  }

  static rowToData(row, valueid, query, type) {
    return {
      id: row.id,
      listName: row.listName,
      useForSending: row.useForSending,
      isFavorite: row.favorite,
      createdDateTime: row.syscreateddatetime,
      valueid: valueid,
      query: query,
      type: type
    };
  }

  static updateFilterList(sysLastValueId, value, callBack) {
    SystemService.doRequest(new SysLastValueWrite(sysLastValueId, value), (response) => {
      callBack(response.success);
    }, 'Es konnten keine Daten geliefert werden!');
  }

  static deleteFilterList(sysLastValueId, callBack) {
    SystemService.doRequest(new SysLastValueDelete(sysLastValueId), (response) => {
      callBack(response.success);
    }, 'Es konnten keine Daten geliefert werden!');
  }

  static buildSysLastValueId(campaignId, entityName, listName) {
    if (!listName) {
      listName = '';
    }
    listName = listName.replace(/\\/g, '-');
    let sysLastValueId = 'cner21/campaign/' + campaignId + '/' + entityName + '/query/' + listName;
    sysLastValueId = sysLastValueId.replace(/\\/g, '/');
    return sysLastValueId;
  }

  private_initColumns() {
    return [{field: 'listName', headerName: 'Listenname', width: 200, editable: false},
      {field: 'useForSending', headerName: 'Versandliste', width: 120, editable: false},
      {field: 'isFavorite', headerName: 'Ist Favorit', width: 90, editable: false},
      {field: 'createdDateTime', headerName: 'Erstellt am', width: 90, editable: false},
    ];
  }

  handleOnRowSelectionModelChange = (record) => {
    if (typeof record[0] === 'number') {
      this.state.actualRowId = record[0];
    } else {
      this.state.actualRowId = -1;
    }
    if (this.props.onRowChanged) {
      this.props.onRowChanged(this.getDataRecord());
    }
    this.state.selectionModel = record;
  }

  onClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
    this.setStatus({});
  }

  onDone = () => {
    if (this.props.onDone) {
      let dataRecord = this.getDataRecord();
      if (dataRecord) {
        this.props.onDone(this.getDataRecord());
        this.state.actualRowId = -1;
        this.onClose();
      } else {
        toast.error('Es sind keine Daten ausgewählt!');
      }
    }
  }

  doOpenNewFilterEntryDialog(e, mode) {
    if (this.state.actualRowId > -1 || mode === 'add') {
      let listName = '';
      let useForSending = false;
      switch (mode) {
        case 'add':
          break;
        case 'update':
          listName = this.props.rows[this.state.actualRowId].listName;
          useForSending = this.props.rows[this.state.actualRowId].useForSending;
          break;
        default:
          break;
      }
      this.setState({
        mode: mode,
        openNewFilterEntryDialog: true,
        nameOfList: listName,
        useForSending: useForSending
      });
    } else {
      toast.warning('Es ist keine Zeile ausgewählt!');
    }
  }

  deleteSysLastValue(e) {
    if (this.state.actualRowId > -1) {
      this.setState({openYesNo: true, mode: ''});
    } else {
      toast.warning('Es ist keine Zeile ausgewählt!');
    }
  }

  yesNoDialogYesAction = () => {
    this.setState({openYesNo: false});

    let dataRecord = this.getDataRecord();
    if (dataRecord) {
      FilterListDialog.deleteFilterList(dataRecord.valueid, (success) => {
        if (success) {
          this.props.parent.doLoadFilterListDialog();
        }
      });
    } else {
      toast.error('Es sind keine Daten ausgewählt!');
    }
  }

  getDataRecord = () => {
    let dataRecord = null;
    let record = null;
    if (this.state.actualRowId > -1) {
      record = this.props.rows[this.state.actualRowId];
    }
    if (record) {
      dataRecord = this.props.data[record.id];
      if (!dataRecord || !dataRecord.hasOwnProperty('valueid')) {
        dataRecord = null;
      }
    }
    return dataRecord;
  }

  yesNoDialogNoAction = () => {
    this.setState({openYesNo: false, mode: ''});
  }

  doneDialogNewFilterEntry = () => {
    let listNameValue = this.newFilterEntryDialogRef.current.state.listNameValue;
    let useForSending = this.newFilterEntryDialogRef.current.state.useForSending;
    let valueid = '';
    let filterProperties = null;
    switch (this.state.mode) {
      case 'add':
        valueid = FilterListDialog.buildSysLastValueId(this.props.campaignId, this.props.entityName, listNameValue);
        filterProperties = new FilterProperties(listNameValue, useForSending, false, 'filter', this.props.query, null);
        break;
      case 'update':
        let dataElement = this.props.data[this.state.actualRowId];
        if (dataElement) {
          valueid = dataElement.valueid;
          filterProperties = new FilterProperties(listNameValue, useForSending, dataElement.isFavorite, dataElement.type, dataElement.query, dataElement.createdDateTime);
        }
        break;
      default:
        break;
    }
    if (valueid && filterProperties && listNameValue) {
      FilterListDialog.updateFilterList(valueid, filterProperties, (success) => {
        if (success) {
          toast.success('Der Filter wurde erfolgreich angepasst.');
          this.props.parent.doLoadFilterListDialog();
        } else {
          toast.error('Der Filter konnte nicht angepasst werden!');
        }
      });
    } else {
      toast.warning('Der Name der Liste muss ausgewählt werden!');
    }
    this.setState({openNewFilterEntryDialog: false, mode: ''});
  }

  createDialogBody() {
    return <><Dialog
      open={this.props.open}
      maxWidth={false}
      scroll={'paper'}
      fullWidth={false}>
      <DialogTitle>
        <Box className='flex justify-between gap-5'>
          {T.label_filter_filter_manager()}
          {this.props.canClose && <IconButton size='small' onClick={this.onClose}><Close/></IconButton>}
        </Box>
      </DialogTitle>
      <DialogContent dividers={true}>
        {this.createDialogContent()}
      </DialogContent>
      {<DialogActions>{<>
        <LoadingButton
          loading={this.state.isLoading}
          variant='contained'
          onClick={this.onDone}>
          {T.action_apply()}
        </LoadingButton></>}</DialogActions>}
    </Dialog>
      <DialogNewFilterEntry open={this.state.openNewFilterEntryDialog} nameOfList={this.state.nameOfList}
                            useForSending={this.state.useForSending} onClose={() => {
        this.setState({openNewFilterEntryDialog: false});
      }} onDone={this.doneDialogNewFilterEntry} ref={this.newFilterEntryDialogRef}/>
      <ConfirmationDialog
        key={shortid()}
        isOpen={this.state.openYesNo}
        isLoading={false}
        title={'Filter löschen'}
        onCancelClick={this.yesNoDialogNoAction}
        onConfirmClick={this.yesNoDialogYesAction}
        confirmButtonColor='error'>
        <div>Möchtest du fortfahren?</div>
      </ConfirmationDialog>
      <ConfirmationDialog
        onConfirmClick={(e) => this.setState({openAlertNoDataSelectionDialog: false})}
        title='Gespeicherter Filter'
        isOpen={this.state.openAlertNoDataSelectionDialog}
        confirmButtonColor='error'
        showCancelButton={false}
        confirmButtonText='Schliessen'>
        Es ist kein Filter ausgewählt!
      </ConfirmationDialog>
    </>;
  }

  createSimpleBody() {
    return <Box className='flex justify-between gap-5'>
        {this.createDialogContent()}
      </Box>;
  }

  createDialogContent() {
    let headerButtons = <TableButtonGroup ref={createRef()} showExtendedFilterButton={false} onRefreshListener={this.onRefreshListener}>
      {this.props.canEdit && <Button tooltip={T.label_add()} uid='ADD' onClick={(e) => this.doOpenNewFilterEntryDialog(e, 'add')}>
        {<Add/>}
      </Button>}
      {this.props.canEdit && <Button tooltip={T.label_edit()} uid='EDIT' onClick={(e) => this.doOpenNewFilterEntryDialog(e, 'update')}>
        {<Edit/>}
      </Button>}
      {this.props.canEdit && <Button tooltip={T.label_delete()} uid='DELETE' onClick={(e) => this.deleteSysLastValue(e)}>
        {<Delete/>}
      </Button>}
    </TableButtonGroup>;

    return <VerticalLayout className='gap-2'>
      {headerButtons}
      {<Grid container spacing={2}>
        <DataGrid
          editMode="row"
          onRowSelectionModelChange={this.handleOnRowSelectionModelChange}
          rowSelectionModel={this.state.selectionModel}
          processRowUpdate={this.onDataGridRowUpdate}
          ref={this.tableRef}
          columns={this.private_initColumns()}
          rows={this.props.rows}
          localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
          slots={{toolbar: GridToolbar, noRowsOverlay: FilterListDialog.private_customNoRowsOverlay}}
          slotProps={{
            toolbar: {
              printOptions: {disableToolbarButton: true},
              csvOptions: {disableToolbarButton: true}
            }
          }}
          columnHeaderHeight={44}
          rowHeight={44}
          showColumnVerticalBorder
          showCellVerticalBorder
          hideFooterPagination
          checkboxSelection
          disableMultipleRowSelection
          disableColumnFilter
          sx={{'--DataGrid-overlayHeight': '300px', minHeight: '400px'}}
        />
      </Grid>}
    </VerticalLayout>;
  }

  render() {
    if (this.props.open) {
      return this.props.displayMode === 'inline' ? this.createSimpleBody(): this.createDialogBody();
    } else {
      return <></>;
    }
  }
}

FilterListDialog.propTypes = {
  parent: PropTypes.any.isRequired,
  open: PropTypes.bool.isRequired,
  rows: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  campaignId: PropTypes.string.isRequired,
  entityName: PropTypes.string.isRequired,
  canClose: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool.isRequired,
  displayMode: PropTypes.oneOf(['inline', 'outline']).isRequired,
  query: PropTypes.object,
  onClose: PropTypes.func,
  onDone: PropTypes.func,
  onRowChanged: PropTypes.func
}
export default FilterListDialog;
